import React from "react";
import { Users, Target, Award, Rocket, Code2, Heart } from "lucide-react";

export default function About() {
  const team = [
    {
      name: "Rizwan Hawwari",
      role: "Founder & CEO",
      image: "https://i.imgur.com/L7gbVzd.png",
      bio: "Dedicated to crafting cutting-edge solutions and driving excellence with vision and determination.",
    },
  ];

  const values = [
    {
      icon: <Target className="w-8 h-8 text-blue-600" />,
      title: "Mission",
      description:
        "To provide high-quality, innovative web solutions that help businesses grow and succeed in the digital world.",
    },
    {
      icon: <Award className="w-8 h-8 text-blue-600" />,
      title: "Excellence",
      description:
        "We strive for excellence in everything we do, from code quality to customer service.",
    },
    {
      icon: <Heart className="w-8 h-8 text-blue-600" />,
      title: "Passion",
      description:
        "Our team is passionate about technology and creating solutions that make a difference.",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      {/* Hero Section */}
      <div className="text-center mb-16">
        <h1 className="text-4xl font-bold mb-6 dark:text-white">
          About RXS Technology
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
          We are a team of passionate developers and designers dedicated to
          creating exceptional web solutions that help businesses thrive in the
          digital age.
        </p>
      </div>

      {/* Values Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        {values.map((value, index) => (
          <div
            key={index}
            className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg text-center"
          >
            <div className="flex justify-center mb-4">{value.icon}</div>
            <h3 className="text-xl font-semibold mb-4 dark:text-white">
              {value.title}
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              {value.description}
            </p>
          </div>
        ))}
      </div>

      {/* Stats Section */}
      <div className="bg-blue-600 text-white rounded-lg p-8 mb-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">2+</div>
            <div className="text-blue-100">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">10+</div>
            <div className="text-blue-100">Projects Completed</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">20+</div>
            <div className="text-blue-100">Happy Clients</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-2">24/7</div>
            <div className="text-blue-100">Support</div>
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="mb-16">
        <h2 className="text-3xl font-bold text-center mb-12 dark:text-white">
          Our Team
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {team.map((member, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-80 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2 dark:text-white">
                  {member.name}
                </h3>
                <p className="text-blue-600 dark:text-blue-400 mb-4">
                  {member.role}
                </p>
                <p className="text-gray-600 dark:text-gray-300">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Technology Stack */}
      <div className="text-center">
        <h2 className="text-3xl font-bold mb-8 dark:text-white">
          Our Technology Stack
        </h2>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="flex flex-col items-center">
              <Code2 className="w-12 h-12 text-blue-600 mb-4" />
              <h3 className="text-lg font-semibold dark:text-white">React</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Frontend Development
              </p>
            </div>
            <div className="flex flex-col items-center">
              <Rocket className="w-12 h-12 text-blue-600 mb-4" />
              <h3 className="text-lg font-semibold dark:text-white">Node.js</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Backend Development
              </p>
            </div>
            <div className="flex flex-col items-center">
              <Users className="w-12 h-12 text-blue-600 mb-4" />
              <h3 className="text-lg font-semibold dark:text-white">
                TypeScript
              </h3>
              <p className="text-gray-600 dark:text-gray-300">Type Safety</p>
            </div>
            <div className="flex flex-col items-center">
              <Award className="w-12 h-12 text-blue-600 mb-4" />
              <h3 className="text-lg font-semibold dark:text-white">
                Tailwind CSS
              </h3>
              <p className="text-gray-600 dark:text-gray-300">Styling</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
